import { fork, put } from "redux-saga/effects";
import ChapterSaga from "../modules/admin-modules/chapters/Saga";
import EventSaga from "../modules/admin-modules/events/Saga";
import ExamSaga from "../modules/admin-modules/exams/Saga";
import gradeSaga from "../modules/admin-modules/grades/Saga";
import GroupSaga from "../modules/admin-modules/groups/Saga";
import HomeworkSaga from "../modules/admin-modules/homework/Saga";
import LectureSaga from "../modules/admin-modules/lectures/Saga";
import LessonSaga from "../modules/admin-modules/lessons/Saga";
import { default as AdminLiveVideosSaga } from "../modules/admin-modules/liveVideos/Saga";
import PaymentSaga from "../modules/admin-modules/payment/Saga";
import PlaylistSaga from "../modules/admin-modules/playlists/Saga";
import QuestionBankSaga from "../modules/admin-modules/questions-bank/Saga";
import AdminSectionSaga from "../modules/admin-modules/sections/Saga";
import StudentSaga from "../modules/admin-modules/students/Saga";
import SubjectSaga from "../modules/admin-modules/subjects/Saga";
import TagSaga from "../modules/admin-modules/tags/Saga";
import TeacherSaga from "../modules/admin-modules/teachers/Saga";
import TeacherAssistantSaga from "../modules/admin-modules/teachersAssistant/Saga";
import VideoSaga from "../modules/admin-modules/videos/Saga";
import authSaga from "../modules/auth/Saga";
import PublicSaga from "../modules/public/publicData/Saga";
import StudentChapter from "../modules/students-modules/chapters/Saga";
import StudentCourseSaga from "../modules/students-modules/courses/Saga";
import chapterExamSaga from "../modules/students-modules/exams/Saga";
import StudentGroupSaga from "../modules/students-modules/groups/Saga";
import chapterHomeworkSaga from "../modules/students-modules/homework/Saga";
import chapterLessonSaga from "../modules/students-modules/lessons/Saga";
import StudentLiveVideosSaga from "../modules/students-modules/live-videos/Saga";
import studentPerformance from "../modules/students-modules/performance/Saga";
import questionsSaga from "../modules/students-modules/questions/Saga";
import SectionsSaga from "../modules/students-modules/sections/Saga";
import studentExamSaga from "../modules/students-modules/student-exams/Saga";
import SystemSubjectSaga from "../modules/students-modules/subjects/Saga";
import chapterVideoSaga from "../modules/students-modules/videos/Saga";
import SuperadminBucketSaga from "../modules/superadmin-modules/bucket/Saga";
import SuperadminChapterSaga from "../modules/superadmin-modules/chapters/Saga";
import CourseSaga from "../modules/superadmin-modules/courses/Saga";
import SuperadminExamSaga from "../modules/superadmin-modules/exams/Saga";
import SuperadminGroupSaga from "../modules/superadmin-modules/groups/Saga";
import SuperadminHomeworkSaga from "../modules/superadmin-modules/homework/Saga";
import SuperadminPdfSaga from "../modules/superadmin-modules/lectures/Saga";
import SuperadminLiveVideosSaga from "../modules/superadmin-modules/live-videos/Saga";
import SuperadminPaymentSaga from "../modules/superadmin-modules/payment/Saga";
import SuperadminQuestionBankSaga from "../modules/superadmin-modules/questions-bank/Saga";
import redoRequestsSaga from "../modules/superadmin-modules/redo-requests/Saga";
import ReportsSaga from "../modules/superadmin-modules/reports/Saga";
import SuperadminSectionSaga from "../modules/superadmin-modules/sections/Saga";
import SuperadminStudentsSaga from "../modules/superadmin-modules/students/Saga";
import SuperadminSubjectSaga from "../modules/superadmin-modules/subjects/Saga";
import SuperadminTagSaga from "../modules/superadmin-modules/tags/Saga";
import SuperadminTeacherSaga from "../modules/superadmin-modules/teachers/Saga";
import RequestSaga from "../modules/superadmin-modules/video-requests/Saga";
import SuperadminVideoSaga from "../modules/superadmin-modules/videos/Saga";
import userSaga from "../modules/user/Saga";
import { appReadyAction } from "./globalActions";

export default function* () {
  yield put(appReadyAction());
  yield fork(authSaga);
  yield fork(userSaga);
  yield fork(LessonSaga);
  yield fork(TeacherSaga);
  yield fork(VideoSaga);
  yield fork(StudentSaga);
  yield fork(GroupSaga);
  yield fork(gradeSaga);
  yield fork(SubjectSaga);
  yield fork(LectureSaga);
  yield fork(ChapterSaga);
  yield fork(ExamSaga);
  yield fork(QuestionBankSaga);
  yield fork(TagSaga);
  yield fork(PlaylistSaga);
  yield fork(StudentChapter);
  yield fork(chapterVideoSaga);
  yield fork(chapterLessonSaga);
  yield fork(chapterExamSaga);
  yield fork(EventSaga);
  yield fork(TeacherAssistantSaga);
  yield fork(questionsSaga);
  yield fork(RequestSaga);
  yield fork(ReportsSaga);
  yield fork(studentExamSaga);
  yield fork(studentPerformance);
  yield fork(redoRequestsSaga);
  yield fork(PaymentSaga);
  yield fork(HomeworkSaga);
  yield fork(chapterHomeworkSaga);
  yield fork(SectionsSaga);
  yield fork(AdminLiveVideosSaga);

  yield fork(AdminSectionSaga);
  yield fork(SystemSubjectSaga);
  yield fork(CourseSaga);
  yield fork(SuperadminSubjectSaga);
  yield fork(SuperadminTeacherSaga);
  yield fork(SuperadminChapterSaga);
  yield fork(SuperadminStudentsSaga);
  yield fork(SuperadminVideoSaga);
  yield fork(SuperadminLiveVideosSaga);
  yield fork(SuperadminPaymentSaga);
  yield fork(SuperadminPdfSaga);
  yield fork(SuperadminTagSaga);
  yield fork(SuperadminBucketSaga);
  yield fork(SuperadminQuestionBankSaga);
  yield fork(SuperadminExamSaga);
  yield fork(SuperadminSectionSaga);
  yield fork(SuperadminGroupSaga);
  yield fork(PublicSaga);
  yield fork(StudentCourseSaga);
  yield fork(StudentGroupSaga);
  yield fork(StudentLiveVideosSaga);
  yield fork(SuperadminHomeworkSaga);
}
